import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectIsShowScopeSection = createSelector(
  [selectComposedReportState],
  ({ isShowScopeSection }) => isShowScopeSection
)
